/* eslint-disable no-restricted-globals */

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

let deferredPrompt = null;

// Check if app is installed
export function isAppInstalled() {
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
  const isIOSStandalone = 'standalone' in window.navigator && window.navigator.standalone === true;
  const isAndroidIntent = document.referrer.includes('android-app://');

  // console.log('serviceWorkerRegistration: isAppInstalled checks', {
  //   isStandalone,
  //   isIOSStandalone,
  //   isAndroidIntent,
  //   userAgent: navigator.userAgent,
  //   displayMode: window.matchMedia('(display-mode: standalone)').matches ? 'standalone' : 'browser'
  // });

  return isStandalone || isIOSStandalone || isAndroidIntent;
}

export function register(config) {
  if ('serviceWorker' in navigator) {
    console.log('serviceWorkerRegistration: Service worker supported');
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      // Handle beforeinstallprompt event
      window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault(); // Prevent the mini-infobar from appearing
        deferredPrompt = e;
        
        if (!isAppInstalled() && config?.onInstallPrompt) {
          config.onInstallPrompt();
        }
      });

      // Handle app installation
      window.addEventListener('appinstalled', () => {
        deferredPrompt = null;
        localStorage.setItem('installPromptShown', 'true');
      });

      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);
        navigator.serviceWorker.ready.then(() => {});
      } else {
        registerValidSW(swUrl, config);
      }
    });
  }
}

export function promptInstall() {
  console.log('serviceWorkerRegistration: promptInstall called, deferredPrompt:', !!deferredPrompt);
  
  if (deferredPrompt) {
    deferredPrompt.prompt();
    deferredPrompt.userChoice.then((choiceResult) => {
      console.log('serviceWorkerRegistration: User choice:', choiceResult.outcome);
      if (choiceResult.outcome === 'accepted') {
        console.log('serviceWorkerRegistration: User accepted the install prompt');
        localStorage.setItem('installPromptShown', 'true');
      }
      deferredPrompt = null;
    });
  } else {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isAndroid = /Android/.test(navigator.userAgent);
    
    if (isIOS) {
      alert('To install this app on your iOS device, tap the Share button and select "Add to Home Screen"');
    } else if (isAndroid) {
      alert('To install this app, tap the menu (⋮) and select "Add to Home Screen" or "Install App"');
    } else {
      alert('To install this app, look for "Add to Home Screen" or "Install" option in your browser menu');
    }
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log('serviceWorkerRegistration: Service worker registered');
      setupUpdateChecker(registration, config);

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (!installingWorker) return;

        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              if (isAppInstalled() && config?.onUpdate) {
                config.onUpdate(registration);
              }
            } else if (config?.onSuccess) {
              config.onSuccess(registration);
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('serviceWorkerRegistration: Error during service worker registration:', error);
    });
}

function setupUpdateChecker(registration, config) {
  const checkForUpdate = () => {
    if (document.hidden) return;
    console.log('serviceWorkerRegistration: Checking for updates');
    registration.update()
      .then(() => {
        if (registration.waiting && isAppInstalled() && config?.onUpdate) {
          console.log('serviceWorkerRegistration: Update available');
          config.onUpdate(registration);
        }
      })
      .catch((error) => {
        console.error('serviceWorkerRegistration: Error during update check:', error);
      });
  };

  // Immediate check
  setTimeout(checkForUpdate, 1000);

  // Periodic check every 30 seconds
  const updateInterval = setInterval(checkForUpdate, 30000);

  // Check on visibility change or focus
  const updateOnEvent = () => setTimeout(checkForUpdate, 1000);
  document.addEventListener('visibilitychange', updateOnEvent);
  window.addEventListener('focus', updateOnEvent);

  // Listen for messages from service worker
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'UPDATE_AVAILABLE' && isAppInstalled() && config?.onUpdate) {
      console.log('serviceWorkerRegistration: Received UPDATE_AVAILABLE message');
      config.onUpdate(registration);
    }
  });

  // Cleanup on unload
  window.addEventListener('beforeunload', () => clearInterval(updateInterval));
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => window.location.reload());
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('serviceWorkerRegistration: No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister().then(() => {
          console.log('serviceWorkerRegistration: Service worker unregistered');
        });
      })
      .catch((error) => {
        console.error('serviceWorkerRegistration: Error unregistering service worker:', error);
      });
  }
}